import { render, staticRenderFns } from "./cjContent.vue?vue&type=template&id=c19ebe0a&scoped=true"
import script from "./cjContent.vue?vue&type=script&lang=js"
export * from "./cjContent.vue?vue&type=script&lang=js"
import style0 from "./cjContent.vue?vue&type=style&index=0&id=c19ebe0a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19ebe0a",
  null
  
)

export default component.exports